import React, { RefObject, useEffect, useState } from "react";
import SceneViewer from "./Components/SceneViewer";
import "./Components/WorkspaceSceneController.scss";
import { CoordinateDisplay, Mode } from "./Components/CoordinateDisplay";
import * as THREE from "three";

const STLViewer = (props) => {
  const [fileName, setFileName] = useState("");
  const [showCoordinateEdits, showCoordinateEditsSet] = useState(false);
  const [activeTool, setActiveTool] = useState<"rotate" | "snap" | null>(null);

  useEffect(() => {
    setFileName(props.modelName);
  }, [props.modelName]);

  //const sceneViewerRef: RefObject<SceneViewer> = React.createRef();
  const sceneViewerRef = React.useRef<SceneViewer>(null);

  const toggleTranslate = () => {
    setCurrentMode(Mode.Translate);
    sceneViewerRef.current?.toggleTranslate();
  };

  const toggleRotate = () => {
    if (activeTool === "rotate") {
      sceneViewerRef.current?.toggleRotate();
      setActiveTool(null);
      setCurrentMode(Mode.None);
    } else {
      if (activeTool === "snap") {
        sceneViewerRef.current?.toggleSnap();
      }

      sceneViewerRef.current?.toggleRotate();
      setActiveTool("rotate");
      setCurrentMode(Mode.Rotate);
    }
  };

  const toggleScale = () => {
    setCurrentMode(Mode.Scale);
    sceneViewerRef.current?.toggleScale();
  };

  const toggleOrient = () => {
    setCurrentMode(Mode.Rotate);
    sceneViewerRef.current?.toggleOrient();
  };

  const toggleSnap = () => {
    if (activeTool === "snap") {
      sceneViewerRef.current?.toggleSnap();
      setActiveTool(null);
      setCurrentMode(Mode.None);
    } else {
      // Deactivate Rotate if selected
      if (activeTool === "rotate") {
        sceneViewerRef.current?.toggleRotate();
      }


      sceneViewerRef.current?.toggleSnap();
      setActiveTool("snap");
      setCurrentMode(Mode.None);
    }
  };

  const setShowCoordinateEdits = (show, mesh) => {
    showCoordinateEditsSet(show);
    if (mesh && mesh !== sceneMesh) {
      setSceneMesh(mesh);
      console.log("setShowCoordinateEdits");
    }
  };

  const updateCoordinatesEdit = () => {};

  const updateCoordinates = () => {
    sceneViewerRef.current?.updatePartOrientationValues(false);
  };

  const [xValue, setXValue] = useState("");
  const [yValue, setYValue] = useState("");
  const [zValue, setZValue] = useState("");

  const [sceneMesh, setSceneMesh] = useState(null);
  const [currentMode, setCurrentMode] = useState(Mode.None);

  return (
    <div>
      <section className="plates page review-page">
        <section className="plate view">
          <div>
            <SceneViewer
              ref={sceneViewerRef}
              modelName={fileName}
              partId={props.partId}
              partSourceType={props.sourceType}
              isLoaded={props.isLoaded}
              results={props.showPartDetails}
              violationDetails={props.violationDetails}
              setShowCoordinateEdits={setShowCoordinateEdits}
              updateCoordinatesEdit={updateCoordinatesEdit}
            />

            <>
              <div className="scene-header-text">
                {!props.showPartDetails ? "Orient Part" : "View Results"}
              </div>

              {props.sourceType === "source" && fileName && (
                <div className="scene-controls">
                  <ul>
                    <li
                      className={`rotate-icon ${
                        activeTool === "rotate" ? "active" : ""
                      }`}
                      onClick={toggleRotate}
                    >
                      Rotate
                    </li>

                    <li
                      className={`snap-icon ${
                        activeTool === "snap" ? "active" : ""
                      }`}
                      onClick={toggleSnap}
                    >
                      Snap
                    </li>
                  </ul>

                  {showCoordinateEdits &&
                    currentMode !== Mode.None && (
                      <CoordinateDisplay
                        mesh={sceneMesh || new THREE.Mesh()}
                        refreshToken={true}
                        mode={currentMode}
                        updater={updateCoordinates}
                      />
                    )}
                </div>
              )}
            </>
          </div>
        </section>
      </section>
    </div>
  );
};

export default STLViewer;
